import { CheckCircle2, XCircle, Hourglass, Trash2 } from "lucide-react";
import { AppColorVariant } from "../../theme/AppColorVariant";
import {ClientInstallationStatus} from "./ClientInstallationStatus";

export enum ClientStatus {
  Active = "active",
  Inactive = "inactive",
  PendingUninstall = "pendingUninstall",
  Uninstalled = "uninstalled",
}

export function getClientStatus(
  isActive: boolean,
  installationStatus: ClientInstallationStatus
): ClientStatus {
  if (installationStatus === ClientInstallationStatus.PendingUninstall)
    return ClientStatus.PendingUninstall;

  if (installationStatus === ClientInstallationStatus.Uninstalled)
    return ClientStatus.Uninstalled;

  return isActive 
    ? ClientStatus.Active 
    : ClientStatus.Inactive;
}


export const ClientStatusLabels: Record<ClientStatus, string> = {
  [ClientStatus.Active]: "Active",
  [ClientStatus.Inactive]: "Inactive",
  [ClientStatus.PendingUninstall]: "Pending Uninstall",
  [ClientStatus.Uninstalled]: "Uninstalled",
};

export const ClientStatusColors: Record<ClientStatus, AppColorVariant> = {
  [ClientStatus.Active]: "success",
  [ClientStatus.Inactive]: "danger",
  [ClientStatus.PendingUninstall]: "warning",
  [ClientStatus.Uninstalled]: "neutral",
};

export const ClientStatusIcons: Record<ClientStatus, React.ElementType> = {
  [ClientStatus.Active]: CheckCircle2,
  [ClientStatus.Inactive]: XCircle,
  [ClientStatus.PendingUninstall]: Hourglass,
  [ClientStatus.Uninstalled]: Trash2,
};
